import { MxRegExpMask } from './masks/mx-regexp-mask';
import { MxColorMask } from './masks/mx-color-mask';
import { MxNumericMask } from './masks/mx-numeric-mask';
import { MxIntervalMask } from './masks/mx-interval-mask';

angular.module('mx.components').directive('mxMask', [
	'$parse',
	'mx.internationalization',
	function mxMaskDirective($parse, i18n) {
		return {
			restrict: 'A',
			require: ['?ngModel'],
			link: function (scope, element, attrs, ngModel) {
				if (!ngModel[0]) {
					throw new Error(i18n.get('components.errors.mx_mask_without_ng_model'));
				}

				const locale = i18n.getLocale();

				const modelCtrl = ngModel[0];
				const maskType = attrs.mxMask;
				const noFormat = attrs.mxMaskNoFormat === 'true';
				const format = attrs.mxMaskFormat;

				let mask = null;
				switch (maskType) {
					case 'integer':
					case 'LongType':
					case 'IntType':
						mask = new MxNumericMask(0, noFormat, true, maskType);
						break;
					case 'float':
					case 'FloatType':
						mask = new MxNumericMask(30, noFormat, true, maskType);
						break;
					case 'DecimalType':
						mask = new MxNumericMask(+attrs.scale || 2, noFormat, true, maskType);
						break;
					case 'currency':
						mask = new MxNumericMask(2, false, true, maskType);
						break;
					case 'interval':
						mask = new MxIntervalMask();
						break;
					case 'color':
						mask = new MxColorMask(format);
						break;
					default:
						mask = new MxRegExpMask();
						break;
				}

				mask.link(scope, element, attrs, modelCtrl, locale, $parse, i18n);
			},
		};
	},
]);
